<div class="portfolio__body">
  <div class="table-container portfolio__table">
    <div class="table-container__header">
      <dsy-heading level="h2" level-size="xl" level-style="bold"> {{ 'PD.PERFORMANCE.TABLE' | translate }} </dsy-heading>
      <dsy-button
        (click)="exportCSV()"
        variant="link"
        icon-side="left"
        icon-name="download"
        icon-size="1.16rem"
        icon-library="material"
        [disabled]="isLoading() || filteredRowsSignal().length === 0"
      >
        {{ 'PD.BUTTONS.DOWNLOAD' | translate }}
      </dsy-button>
    </div>
    <fdr-past-performance-ui-dispatch-portfolio-filters
      [organizations]="organizationsSignal()"
      [sites]="sitesSignal()"
      (appliedFiltersChange)="onAppliedFiltersChange($event)"
    ></fdr-past-performance-ui-dispatch-portfolio-filters>
    <fdr-past-performance-ui-registration-details #registrationTable [rows]="filteredRowsSignal()" [isLoading]="isLoading()"></fdr-past-performance-ui-registration-details>
  </div>
</div>
